import React, { useContext } from "react";
import Barcode from "react-barcode";
import useT from "../../hooks/useT";
import { APP_PAGE, actions } from "../../hooks/useAppState";
import { PicklistFieldConfig } from "../../types";
import { get } from "../../utils/helpers";
import { getConfigValue } from "../../config";
import Button from "../../components/Button";
import { AppStateContext } from "../../containers/App";
import {
  CustomerDataStateObject,
  setCustomerDataState
} from "../../hooks/useCustomerDataState";
import { ReactSelectOptionObject } from "../InputSelectCustom";
import debug from "../../utils/debug";
import "./CustomerDetails.css";

export interface CustomerDetailsProps {
  customer: CustomerDataStateObject;
  columns: string[] | ReactSelectOptionObject[];
  enableEdit?: boolean;
  t: Function;
}

export default function CustomerDetails({
  customer,
  columns,
  enableEdit,
  t
}: CustomerDetailsProps) {
  const useTCountries = useT("countries");
  const tCountries = useTCountries.t;
  const [, doAppStateAction] = useContext(AppStateContext);
  const picklistsConfig = getConfigValue("", "customise.fields.picklistValues");

  const edit = () => {
    setCustomerDataState(customer);
    doAppStateAction(actions.setPage(APP_PAGE.CUSTOMER));
  };
  debug("[CustomerDetails] customer:", customer);
  debug("[CustomerDetails] columns:", columns);
  let showBarcode = false;
  const values: ReactSelectOptionObject[] = [];
  columns.forEach((column: string | ReactSelectOptionObject) => {
    if (typeof column === "string" && column === "barcode") {
      showBarcode = true;
      return;
    }
    const fieldName = typeof column === "string" ? column : column.value;
    const label =
      typeof column === "string"
        ? "customer.data.fields." + column + ".label"
        : column.label;
    const columnType = get(column, "type");
    let value = fieldName && customer[fieldName];
    let options = get(column, "options");

    // get options from config
    if (!options && columnType === "customPicklist" && picklistsConfig) {
      const picklistConfig = picklistsConfig.find(
        (pvConfig: PicklistFieldConfig) => pvConfig.name === fieldName
      );
      options = picklistConfig && picklistConfig.options;
    }
    if (value && options) {
      const option = options.find(
        (option: ReactSelectOptionObject) => option.value === value
      );
      if (option) {
        value = t(option.label);
      }
    }
    if (fieldName === "addressCountry" || columnType === "country") {
      value = tCountries(value);
    }
    if (value) {
      values.push({ label, value });
    }
  });
  debug("[CustomerDetails] values:", values);

  return (
    <div>
      {values.map((column, index) => (
        <div key={index} className="field">
          <div className="label field-label">{t(column.label)}</div>
          <div className="value">{column.value}</div>
        </div>
      ))}
      <div className="barcode">
        {customer.barcode && showBarcode && (
          <Barcode value={customer.barcode} format="CODE128" />
        )}
      </div>
      <br />
      {enableEdit && (
        <Button label={t("search.table.edit")} theme="primary" onClick={edit} />
      )}
    </div>
  );
}
